import React from "react";
import { Helmet } from "react-helmet";
import { FormattedMessage, useIntl } from "react-intl";
import { TAG_RESULTS_PER_PAGE } from "constants/index";
import PageTitle from "components/PageTitle";
import { TagList } from "components/Tags";
import { Grid, PageWrapper } from "components/Containers";

/**
 * Tag Manager
 */
const TagManager = () => {
  const intl = useIntl();

  return (
    <PageWrapper>
      <Helmet>
        <title>{intl.formatMessage({ id: "Settings.Tags.Title" })}</title>
      </Helmet>
      <Grid>
        <Grid.col start={1} end={13}>
          <PageTitle subtitle={<FormattedMessage id={`Settings.Tags.Title`} />} />
        </Grid.col>
        <Grid.col start={1} end={13}>
          <TagList resultsPerPage={TAG_RESULTS_PER_PAGE} />
        </Grid.col>
      </Grid>
    </PageWrapper>
  );
};

export default TagManager;
